import React, { Component } from 'react';
import { Col, Row, Button } from "react-bootstrap";
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import API from '../../services/API';
import FieldGroup from "../../components/FieldGroup";
import SelectWrap from "../../components/SelectWrap";
import { handleFieldChange } from "../../Utils";
import { API_URL } from "../../data/config";

class BidderClickLog extends Component {
    constructor() {
        super();

        this.state = {
            dateFrom: '',
            dateTo: '',
            source: null,
            availableSources: []
        };

        this.handleFieldChange = handleFieldChange.bind(this);
    }

    componentDidMount() {
        this.loadSources();
    }

    loadSources() {
        this.setState({ isLoading: true });

        API.BidderClickLog.getAvailableSources().then(sources => this.setState({ availableSources: sources, isLoading: false }));
    }

    render() {
        const { isLoading, source, dateFrom, dateTo } = this.state;
        const url = `${API_URL}bidderClickLog?dateFrom=${dateFrom}&dateTo=${dateTo}&source=${source}`

        return (
            <Container loading={isLoading}>
                <Heading title="Bidder Click Log"/>

                <Row>
                    <Col lg={4}>
                        <FieldGroup
                            type="date"
                            name="dateFrom"
                            label="Date From:"
                            onChange={this.handleFieldChange}
                            value={this.state.dateFrom}
                        />
                    </Col>
                    <Col lg={4}>
                        <FieldGroup
                            type="date"
                            name="dateTo"
                            label="Date To:"
                            onChange={this.handleFieldChange}
                            value={this.state.dateTo}
                        />
                    </Col>
                    <Col lg={4}>
                        <SelectWrap
                            value={this.state.source}
                            name="source"
                            label="Source:"
                            values={this.state.availableSources}
                            onChange={this.handleFieldChange}
                            required
                        />
                    </Col>
                </Row>
                <Button href={url} disabled={!(source && dateFrom && dateTo)}>Download</Button>
            </Container>
        );
    }
}

export default BidderClickLog;


// WEBPACK FOOTER //
// ./src/scenes/BidderClickLog/index.js